import React from 'react';
import Sidebar from '@/components/Sidebar';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { UserPictureProvider } from '@/providers/UserPictureProvider';
import { twMerge } from 'tailwind-merge';
import CookieBanner from '@/components/BannerImgText/CookieBanner';

interface BackOfficeLayoutProps {
  hasCustomHeader?: boolean;
  children: React.ReactNode;
}

export const BackOfficeLayout = ({
  hasCustomHeader = false,
  children,
}: BackOfficeLayoutProps) => {
  return (
    <div className="flex grow">
      <Sidebar />
      <div className="wrapper flex grow flex-col">
        <UserPictureProvider>
          <Header />
        </UserPictureProvider>
        <main
          className={twMerge(
            'pt-5 pb-12 grow content bg-light-active dark-mode:bg-coal-500',
            hasCustomHeader && 'bg-secondary-active'
          )}
          id="content"
          role="content"
        >
          <div
            className={twMerge(
              'min-h-[calc(100vh-172px)]',
              !hasCustomHeader && 'container-fixed min-h-[calc(100vh-196px)]'
            )}
            id="content_container"
          >
            {children}
            <CookieBanner />
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};
